import { useState } from "react";
import { Plus } from "lucide-react";
import { DriverProvider } from "./DriverContext";
import { OrdersDeliveryBoys } from "../OrdersDeliveryBoysView";
import { OrderDeliverySamplePickup } from "../OrderDeliverySamplePickup";
import { AddNewDeliveryAgentModal } from "../../../../shared/AddNewDeliveryAgentModal";
import DriverUpdateComponent from "./updateDriver.tsx/updateDetails";

export default function DeliveryBoyPage() {
  const [activeTab, setActiveTab] = useState<"delivery" | "pickup">("delivery");
  const [showAddDriverModal, setShowAddDriverModal] = useState(false);
  const [selectedDriverId, setSelectedDriverId] = useState<string | null>(null);
  const [showDriverUpdateModal, setShowDriverUpdate] = useState(false);
  const [isUpdate,setIsUpdate]=useState(false);
  const [needsReload, setNeedsReload] = useState(false);

  const handleCloseUpdateModal=()=>{
    setShowDriverUpdate(false);
    setNeedsReload(true);
  }

  const handleUpdateButton=(id: string)=>{
    setSelectedDriverId(id);
    setShowDriverUpdate(true);
    setIsUpdate(true);
  }

  const handleViewButton=(id: string)=>{
    setSelectedDriverId(id);
    setShowDriverUpdate(true);
    setIsUpdate(false);
  }
  
  return (
    <DriverProvider>
      {/* Single Add Driver Button */}
      {showDriverUpdateModal?<DriverUpdateComponent driverId={selectedDriverId} onClose={handleCloseUpdateModal} isUpdate={isUpdate}/>:
      <div className="p-6 max-w-[1600px] mx-auto space-y-6">
        {/* Top Header & Actions */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div>
            <h1 className="text-xl font-bold text-gray-900">Drivers</h1>
            <p className="text-xs text-gray-500 mt-0.5">
              Manage your delivery boys and sample pickup personnel
            </p>
          </div>

          <button
            onClick={() => setShowAddDriverModal(true)}
            className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-emerald-600 text-white text-sm font-medium rounded-xl hover:bg-emerald-700 transition-colors shadow-sm whitespace-nowrap"
          >
            <Plus className="w-4 h-4" />
            <span>Add Driver</span>
          </button>
        </div>

        <div className="p-4 bg-white rounded-xl border border-gray-100 shadow-sm">
        {/* Header with tabs and add button */}
        <div className="flex justify-between items-center">
          {/* Tab Switch */}
          <div className="flex space-x-8 border-b border-gray-200">
            <button
              onClick={() => setActiveTab("delivery")}
              className={`pb-3 px-1 font-medium text-sm whitespace-nowrap relative ${
                activeTab === "delivery"
                  ? "text-green-600 border-b-2 border-green-600"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            >
              Delivery Boy 
              {activeTab === "delivery" && (
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-green-600"></div>
              )}
            </button>
            <button
              onClick={() => setActiveTab("pickup")}
              className={`pb-3 px-1 font-medium text-sm whitespace-nowrap relative ${
                activeTab === "pickup"
                  ? "text-green-600 border-b-2 border-green-600"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            >
              Sample pickup Person 
              {activeTab === "pickup" && (
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-green-600"></div>
              )}
            </button>
          </div>
        </div>

        {/* Conditional Component Rendering */}
        
        <div>
          {activeTab === "delivery" ? (
            <OrdersDeliveryBoys handleUpdateButton={handleUpdateButton} handleViewButton={handleViewButton}/>
          ) : (
            <OrderDeliverySamplePickup handleUpdateButton={handleUpdateButton} handleViewButton={handleViewButton}/>
          )}
        </div>

        {/* Add Driver Modal */}
        {showAddDriverModal && (
          <AddNewDeliveryAgentModal
            onClose={() => setShowAddDriverModal(false)}
            driverType={
              activeTab === "delivery" ? "deliveryBoy" : "samplePickUpPerson"
            }
          />
        )}
        </div>
      </div>}
    </DriverProvider>
  );
}
